import { useState, useEffect } from "react";
import { Icons } from "../../components/common/Icons";
import { useEmployeeData } from "../../context/EmployeeContext";
import api from "../../services/api";import "../../assets/styles/Employee/EmpLeaveSummaryWidget.css";

function EmpLeaveSummaryWidget() {
  const { empLeaveSummary } = useEmployeeData();
  const [balance, setBalance] = useState(empLeaveSummary || []);
  const [permBalance, setPermBalance] = useState(null);

  // Always fetch fresh balance from DB (Fix 1: leave count not reducing)
  useEffect(() => {
    api.getLeaveBalance().then((data) => {
      if (data && data.length) {
        const colors = { 'Casual Leave': '#6366f1', 'Sick Leave': '#ef4444', 'Personal Leave': '#f59e0b', 'Comp Off': '#3b82f6', 'Earned Leave': '#2563eb', 'WFH': '#8b5cf6', 'Work From Home': '#8b5cf6', 'Loss of Pay': '#dc2626' };
        setBalance(data.map((l) => ({
          type: l.leave_type || l.type || '',
          total: l.total || 0,
          used: l.used || 0,
          remaining: l.remaining || 0,
          color: l.color || colors[l.leave_type || l.type] || '#6366f1'
        })));
      }
    }).catch(() => {});
    api.getPermissionBalance().then(setPermBalance).catch(() => {});
  }, []);

  // Keep widget synced with latest context refresh (socket/API updates).
  useEffect(() => {setBalance(Array.isArray(empLeaveSummary) ? empLeaveSummary : []);}, [empLeaveSummary]);

  return (
    <div className="card animate-in">
      <div className="card-header"><div className="card-title">Leave Balance</div></div>
      <div className="card-body">
        <div className="leave-grid">
          {balance.map((l, i) =>
          <div className="leave-card" key={i}>
              <div className="leave-dot empleavesummarywidget-dyn-1" style={{ "--empleavesummarywidget-1-background": l.color }} />
              <div className="leave-type">{l.type}</div>
              <div className="leave-count empleavesummarywidget-dyn-2" style={{ "--empleavesummarywidget-2-color": l.color }}>{l.used}<span className="leave-total">/{l.total || "∞"}</span></div>
              {l.total > 0 && <div className="leave-bar"><div className="leave-fill empleavesummarywidget-dyn-3" style={{ "--empleavesummarywidget-3-width": `${l.used / l.total * 100}%`, "--empleavesummarywidget-3-background": l.color }} /></div>}
            </div>
          )}
          {permBalance &&
          <div className="leave-card">
              <div className="leave-dot empleavesummarywidget-inline-1" />
              <div className="leave-type">Permission</div>
              <div className="leave-count empleavesummarywidget-inline-2">
                {permBalance.used || 0}<span className="leave-total">/{permBalance.total || 0}h</span>
              </div>
              <div className="empleavesummarywidget-inline-3">
                Remaining: {permBalance.remaining || 0}h
              </div>
            </div>
          }
        </div>
      </div>
    </div>);

}

export default EmpLeaveSummaryWidget;
